import React from 'react';
import './GetStartedSection.css';
import stepImg1 from '../../assets/getstarted/img1.png';
import stepImg2 from '../../assets/getstarted/img2.png';
import stepImg3 from '../../assets/getstarted/img3.png';

const GetStartedSection = () => {
    return (
        <section className="get-started-section">

            <div className="get-started-container">

                {/* LEFT CONTENT */}
                <div className="get-started-left">
                    <span className="small-badge">Its Easy</span>

                    <h2 className="get-started-title">
                        Get started<br />
                        effortlessly
                    </h2>
                </div>

                {/* RIGHT CONTENT */}
                <div className="get-started-steps">

                    {/* STEP 1 */}
                    <div className="step-card">
                        <div className="step-icon">
                            {/* icon placeholder */}
                            <span><img src={stepImg1} alt="chat with us" /></span>
                        </div>

                        <h3>Let’s Chat</h3>

                        <p>
                            Take the first step. Let us know what time works for you to chat with us! Whether it’s
                            a virtual meeting or in person. We will customize our services to fit your needs.
                        </p>
                    </div>

                    {/* DIVIDER */}
                    <div className="vertical-divider"></div>

                    {/* STEP 2 */}
                    <div className="step-card">
                        <div className="step-icon">
                            <span><img src={stepImg2} alt="discuss your goals" /></span>
                        </div>

                        <h3>Discuss Your Goals</h3>

                        <p>
                            We’ll work with you to understand what exactly you’re looking for,
                            your personal and financial goals as well as your timeline. We want to make your dream come true.
                        </p>
                    </div>

                    {/* DIVIDER */}
                    <div className="vertical-divider"></div>

                    {/* STEP 3 */}
                    <div className="step-card">
                        <div className="step-icon">
                            <span><img src={stepImg3} alt="make it happen" /></span>
                        </div>

                        <h3>Make it Happen</h3>

                        <p>
                            Buying or selling is an emotional process. We get it. Whether it’s finding your dream property or selling your own property,
                            we’ll guide you through the entire process as stress-free as possible.
                        </p>
                    </div>

                </div>

            </div>

        </section>
    );
};

export default GetStartedSection;
